//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        payrollSettle: [],
        searchRequest: null,
      },

      mutations: {
        updatepayrollSettle(state, list) {
          state.payrollSettle = list;
        },
        updateSearchpayrollSettleRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },

      actions: {
        async payrollSettle({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest))



 
          if (requestToSend.settleDate.startDate)
          {
              const date = moment(requestToSend.settleDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
              requestToSend.settleDate.startDate = date.getFullYear() + '-' + month + '-' + day
          }
      
          if (requestToSend.settleDate.endDate)
          {
              const dateTo= moment(requestToSend.settleDate.endDate).add(1,'day');
              const date = moment(dateTo)
                          .endOf('d')
                          .toDate();
      
                          var month = (date.getMonth() + 1).toString()
                          if (month.length == 1)
                          {
                              month = '0' + month
                          }
                  
                          var day = date.getDate().toString()
                          if (day.length == 1)
                          {
                              day = '0' + day
                          }
              requestToSend.settleDate.endDate = date.getFullYear() + '-' + month + '-' + day
          }
          else
          {
            if (requestToSend.settleDate.startDate != null)
            {
              const date = moment(requestToSend.settleDate.startDate)
                          .endOf('d')
                          .toDate();
              console.log(date)
              console.log(date.getMonth())
              console.log(date.getDate())
              var month = (date.getMonth() + 1).toString()
              if (month.length === 1)
              {
                  month = '0' + month
              }
      
              var day = date.getDate().toString()
              if (day.length === 1)
              {
                  day = '0' + day
              }
      
              requestToSend.settleDate.endDate = date.getFullYear() + '-' + month + '-' + day
            }
              
          }


          console.log(requestToSend);

          // const validDate = requestToSend.validOn;
          // requestToSend.validOn = dateFormat.gstDateFormat(validDate);
            const st = performance.now();
            //const result = await api.post('/api/w/apar/settelmentlist', requestToSend);
            const result = await newAPIPost('/api/w/apar/settelmentlist', requestToSend);
            commit('updateSearchpayrollSettleRequest', fallbackRequest);
            console.log(JSON.stringify(result));
            return commit('updatepayrollSettle', result);
            
                },
      },


      getters: {
        getpayrollSettle: state => state.payrollSettle,
      },
}
